import { Organization, OrganizationCreateRequest, OrganizationUpdateRequest } from "@bluefalcon/users-management-client-fetch";
import { useState, useEffect } from "react";
import {
    Button,
    Input,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    FormControl,
    FormLabel,
} from "@chakra-ui/react";

type AddEditOrganizationModalProps = {
    isOpen: boolean;
    organization?: Organization;
    handleAddOrganization: (data: OrganizationCreateRequest) => Promise<void>;
    handleEditOrganization: (organizationId: string, req: OrganizationUpdateRequest) => Promise<void>;
    onClose: () => void;
};

export const AddEditOrganizationModal = ({
    isOpen,
    organization,
    handleAddOrganization,
    handleEditOrganization,
    onClose,
}: AddEditOrganizationModalProps) => {

    const [organizationName, setOrganizationName] = useState(organization?.name ?? '');

    useEffect(() => {
        setOrganizationName(organization?.name ?? '');
    }, [organization]);

    const handleSubmit = async () => {
        if (organization && organizationName.trim()) {
            await handleEditOrganization(organization.id, { name: organizationName.trim() });
        } else if (organizationName.trim()) {
            await handleAddOrganization({ name: organizationName.trim() });
        }
        onCloseModal();
    };

    const onCloseModal = () => {
        setOrganizationName('');
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={onCloseModal}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{organization ? 'Edit Organization' : 'Add Organization'}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <FormControl isRequired>
                        <FormLabel htmlFor="organizationName">Organization Name</FormLabel>
                        <Input
                            id="organizationName"
                            value={organizationName}
                            onChange={(e) => setOrganizationName(e.target.value)}
                            placeholder="Enter Organization Name"
                        />
                    </FormControl>
                </ModalBody>
                <ModalFooter>
                    <Button variant="outline" mr={3} onClick={onCloseModal}>
                        Close
                    </Button>
                    <Button
                        colorScheme="teal"
                        onClick={handleSubmit}
                        isDisabled={!organizationName.trim()}
                    >
                        {organization ? 'Edit Organization' : 'Add Organization'}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};
